/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const LabelContainer = styled.dl({
  display: 'flex',
  flexDirection: 'column',
  marginTop: token('space.100'),
  paddingLeft: 0,
  dd: {
    marginLeft: 0,
  },
});

export const FormatOptionLabelStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const FormatOptionLabelContainerStyled = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const TextAreaFieldContainer = styled.div({
  minWidth: '320px',
  maxWidth: '50%',
});

export const OptionLabelContainer = styled.span({
  marginLeft: token('space.100'),
});
